<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 년도 -->
          <c-datepicker
            :range="true"
            type="year"
            default="today"
            label="LBLYEAR"
            name="years"
            v-model="searchParam.years"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            stepperGrpCd="HEA_MUSCLE_SURVEY_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="heaMuscleSurveyStepCd"
            label="LBLSTEPPROGRESS"
            v-model="searchParam.heaMuscleSurveyStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      title="근골격계질환 증상조사 설문요청 목록"
      :columns="grid.columns"
      :data="grid.data"
      :merge="grid.merge"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 등록 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'hazardInvestigation',
  data() {
    return {
      searchParam: {
        plantCd: null,
        years: [],
        heaMuscleSurveyStepCd: null,
      },
      grid: {
        merge: [
          { index: 0, colName: 'heaInvestigationPlanId' },
          { index: 1, colName: 'heaInvestigationPlanId' },
          { index: 2, colName: 'heaInvestigationPlanId' },
        ],
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: false,
            style: 'width:90px',
          },
          {
            name: 'investigationPlanName',
            field: 'investigationPlanName',
            label: '조사계획명',
            align: 'left',
            sortable: false,
            style: 'width:250px',
            type: 'link'
          },
          {
            name: 'year',
            field: 'year',
            label: 'LBLYEAR',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'worker',
            field: 'worker',
            label: '설문대상',
            child: [
              {
                name: 'deptName',
                field: 'deptName',
                label: 'LBLDEPT',
                align: 'center',
                sortable: false,
                style: 'width:80px',
              },
              {
                name: 'userName',
                field: 'userName',
                label: 'LBLNAME',
                align: 'center',
                sortable: false,
                style: 'width:80px',
              },
              {
                name: 'heaMuscleSurveyStepName',
                field: 'heaMuscleSurveyStepName',
                label: '설문지 작성현황',
                align: 'center',
                sortable: false,
                style: 'width:80px',
              },
            ]
          },
          {
            name: 'processSopNames',
            field: 'processSopNames',
            label: '관련 공정/단위작업',
            align: 'left',
            sortable: false,
            style: 'width:400px',
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.hea.muscleSystem.muscleSurvey.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col) {
      this.popupOptions.title = '근골격계질환 증상조사표 현황';
      this.popupOptions.param = {
        heaInvestigationPlanId: row.heaInvestigationPlanId,
        heaMuscleWorkerSurveyId: row.heaMuscleWorkerSurveyId,
      };
      this.popupOptions.target = () => import(`${'./symptomSurveyStatusDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
